import { PaletteOptions } from "@mui/material/styles";

import { colors } from "./colors";

export const palette: PaletteOptions = {
  background: {
    default: colors.light,
  },
  common: {
    black: colors.dark,
    white: colors.white,
  },
  primary: {
    main: colors.mapped.surface.default,
    contrastText: colors.white,
  },
  secondary: {
    main: colors.mapped.surface.neutralDefault,
    contrastText: colors.white,
  },
  success: {
    main: colors.mapped.surface.default,
    contrastText: colors.white,
  },
  warning: {
    main: colors.mapped.surface.warningDefault,
    contrastText: colors.white,
  },
  info: {
    main: colors.info,
    contrastText: colors.white,
  },
  error: {
    main: colors.mapped.surface.errorDefault,
    contrastText: colors.white,
  },
  action: {
    disabled: colors.white,
    disabledBackground: colors.gray,
  },
  text: {
    primary: colors.dark,
    secondary: colors.gray,
  },
};
